import Organization from '../../types/organization';

/**
 * Processes the organization detail by updating the corresponding organization
 * in the provided organization list. If an organization with a matching ID is found,
 * its properties are updated with the details from the `orgDetail` object.
 *
 * @param orgList An array of `Organization` objects representing the list of organizations.
 * @param orgDetail An `Organization` object containing the updated details of a specific organization.
 * @returns The updated array of `Organization` objects. If an organization with a matching ID
 * is found and updated, the original `orgList` with the modified object is returned.
 * If no matching organization is found, the original `orgList` remains unchanged.
 */
export const orgDetailProcessor = (orgList: Array<Organization>, orgDetail: Organization) => {
  const org = orgList.find(item => item.details.id === orgDetail.details.id);
  if (org) {
    Object.assign(org, orgDetail);
  }

  return orgList;
}